/**
 * @fileoverview Lista canónica de las 16 alcaldías de la CDMX.
 * Códigos de 3 letras (deben coincidir con los del backend en
 * `backend/app/seed/alcaldias.json`).
 */

/**
 * @typedef {Object} Alcaldia
 * @property {string} codigo - código de 3 letras
 * @property {string} nombre - nombre completo
 */

/** @type {Alcaldia[]} */
export const ALCALDIAS = [
    { codigo: "AOB", nombre: "Álvaro Obregón" },
    { codigo: "AZC", nombre: "Azcapotzalco" },
    { codigo: "BJU", nombre: "Benito Juárez" },
    { codigo: "COY", nombre: "Coyoacán" },
    { codigo: "CUA", nombre: "Cuajimalpa" },
    { codigo: "CTM", nombre: "Cuauhtémoc" },
    { codigo: "GAM", nombre: "Gustavo A. Madero" },
    { codigo: "IZC", nombre: "Iztacalco" },
    { codigo: "IZT", nombre: "Iztapalapa" },
    { codigo: "MAC", nombre: "La Magdalena Contreras" },
    { codigo: "MHI", nombre: "Miguel Hidalgo" },
    { codigo: "MIA", nombre: "Milpa Alta" },
    { codigo: "TLH", nombre: "Tláhuac" },
    { codigo: "TLP", nombre: "Tlalpan" },
    { codigo: "VEC", nombre: "Venustiano Carranza" },
    { codigo: "XOC", nombre: "Xochimilco" },
];

/** @type {Alcaldia[]} alfabético por nombre */
export const ALCALDIAS_ORDENADAS = [...ALCALDIAS].sort((a, b) =>
    a.nombre.localeCompare(b.nombre, "es")
);

/**
 * Devuelve el nombre completo dado el código de 3 letras.
 * @param {string | null | undefined} codigo
 * @returns {string}
 */
export function nombreAlcaldia(codigo) {
    if (!codigo) return "";
    const found = ALCALDIAS.find((a) => a.codigo === codigo.toUpperCase());
    return found ? found.nombre : codigo;
}
